export default __webpack_public_path__ + "static/media/grafema_minha-casa_09.258f3b8a.jpg";